import React from 'react';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import '../libs/easing.js'

class BackToTop extends React.Component {
    componentDidMount(){
        $('.back-to-top').click(function(){
            $('html, body').animate({scrollTop : 0},1500, 'easeInOutExpo');
            return false;
          });
        this._scrollHandler = () => {
            const el = document.querySelector('.back-to-top');
            if (!el) return;
            if(window.pageYOffset > 100){
                el.classList.remove("fadeOut");
                el.style.display = "block";
                el.classList.add("fadeIn");
            }else {
                el.classList.remove("fadeIn");
                el.classList.add("fadeOut");
            }
        };
        window.addEventListener('scroll', this._scrollHandler, { passive: true });
    }

    componentWillUnmount(){
        if (this._scrollHandler) {
            window.removeEventListener('scroll', this._scrollHandler);
        }
    }

    render(){
        const { t } = this.props;
        return <a href="#home" className="back-to-top animated" aria-label={t('backToTop')}><i className="fa fa-chevron-up"></i></a>;
    }
}

export default withTranslation()(BackToTop);
